import { useMutation, useQueryClient } from '@tanstack/react-query';
import { recomputeOrderTotals, ordersQueryKeys } from '@api/orders';

// Re-persists the order's stored totals snapshot from the live breakdowns.
// Used by the drawer's Spine Refresh so "Order value" tracks Spine-side
// changes; callers refetch the events query themselves (onSettled) so the
// drawer refreshes even when this write fails.
export function useRecomputeOrderTotals() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (orderId: number) => recomputeOrderTotals(orderId),
    onSuccess: (_order, orderId) => {
      queryClient.invalidateQueries({ queryKey: ordersQueryKeys.lists() });
      queryClient.invalidateQueries({ queryKey: ordersQueryKeys.detail(orderId) });
    },
  });
}
